<template>



<Spinner style="margin-top: 150px;" v-if="!LoadTypeCable"/>

<van-list
v-if="LoadTypeCable"
  :finished="LoadTypeCable"
  class="cursor_card m-t2 m-l-4"
>

<van-cell  v-bind:class="{ 
  color_om1: item.type_fibre == 'OM1' , 
  color_om2: item.type_fibre == 'OM2' ,
  color_om3: item.type_fibre == 'OM3' ,
  color_om4: item.type_fibre == 'OM4' ,
  color_os2: item.type_fibre == 'OS2'
  }"  class="cell_card_type hover_card all_border_radius"   v-for="item in filteredTypeFibre" :key="item.pk_type_fibre" clickable @click="choseTypeFibre(item.pk_type_fibre, item.type_fibre, item.code_ref, item.mode)"  >
  
  <van-row class="row_card">
  <van-col  class="d-content "  span="2">

    <span v-if="item.type_fibre == StoreTypeFibre" style="color:#1989fa">{{ item.type_fibre }}</span>
    <span v-else>{{ item.type_fibre }}</span>

  </van-col>

  <van-col class="d-content " span="2">
    <van-icon v-if="item.type_fibre == StoreTypeFibre" class="icon_check_choice" name="success" color="#1989fa" style="vertical-align: top" size="20" />

  </van-col>

</van-row>

</van-cell>

</van-list>


    </template>

    <script>


    import Spinner from '../../../loader/Spinner.vue'
    
    export default {
      components: {
        Spinner,
      },
      data() {
        return {
          TypeFibre: [],
          LoadTypeCable: false,
          availableTypeFibres: new Set(),
        }
      },
      computed: {
        /** Nombre de fibre */
        StoreTypeFibre() {
          return this.globalFunction.existKeyInArray("type", this.$store.state.storeCable.cable) 
          ? this.$store.state.storeCable.cable.type.TypeFibre
          : null 

            },
        filteredTypeFibre() {
          if (this.availableTypeFibres.size === 0) {
            return this.TypeFibre;
          }
          return this.TypeFibre.filter(type => this.availableTypeFibres.has(type.type_fibre));
        }
      },

      created() {
    this.getTypeFibre();
    this.getStructureFibre();
  
    },
    methods: {
      async getTypeFibre() {
        try {
          //Appel de l'api + transofrmation Json'
          const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/preco_type_fibres' ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": this.$store.state.storeGlobal.StoreJwtToken
    },
    })
          var resultApi = (await res.json());
          this.TypeFibre = resultApi;
       
          //etat environnement tru ou false
          this.etatEnv = resultApi;
          //etat chargement de la page
         
        } catch (error) {
          this.answer = 'Error! Could not reach the API. ' + error
        }
      },
      async getStructureFibre() {
        try {
          const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/preco_refs?' +
            'fk_nb_fibre.nb_fibre=' + this.$store.state.storeCable.cable.nombre.nbFibre +
            '&fk_pays.nom=' + this.$store.state.storeGlobal.StorePays +
            '&fk_env_web.nom=' + this.$store.state.storeGlobal.StoreEnvWeb +
            '&fk_env.nom=' + this.$store.state.storeGlobal.StoreEnv, {
              method: "GET",
              headers: {
                "Accept": "application/json",
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": this.$store.state.storeGlobal.StoreJwtToken
              },
            });

          const resultApi = await res.json();
          // Extraire les types de fibres disponibles
          this.availableTypeFibres = new Set(
            resultApi.map(item => item.fk_type_fibre.type_fibre)
          );
          this.LoadTypeCable = true;
        } catch (error) {
          console.error('Error! Could not reach the API. ', error);
        }
      },
      choseTypeFibre(pkTypeFibre, TypeFibre , TypeFibreCodeRef, ModeFibre){
        
        this.obj = {  
          'cable' : {
            'type' : {
          pkTypeFibre:pkTypeFibre,
          TypeFibre: TypeFibre,
          TypeFibreCodeRef: TypeFibreCodeRef,
          ModeFibre:ModeFibre
        }
        }};
       
        this.$store.commit('SET_CHOICE_CABLE', this.obj )

      }
    },
    
    
    }
    </script>